import { ErrorIcon } from '@medly-components/icons';
import { INCOMPLETE_ONBOARDING } from 'constants/onboarding';
import { FC, useCallback, useState } from 'react';
import { useTheme } from 'styled-components';
import { CloseIcon, ErrorContainer, ErrorContainerWrapper, ErrorText } from './TopErrorBanner.styled';

export const TopErrorBanner: FC = () => {
    const [showError, setShowError] = useState<boolean>(true);
    const theme = useTheme();
    const closeError = useCallback(() => {
        setShowError(false);
    }, [setShowError]);
    if (!showError) {
        return null;
    }
    return (
        <ErrorContainerWrapper>
            <ErrorContainer>
                <ErrorIcon iconColor={theme.colors.error} />
                <ErrorText textVariant="body2" textColor={theme.colors.error}>
                    {INCOMPLETE_ONBOARDING}
                </ErrorText>
            </ErrorContainer>
            <CloseIcon onClick={closeError} iconColor={theme.colors.error} size="S" />
        </ErrorContainerWrapper>
    );
};
